import { Card } from "@/components/ui/card";
import { Users } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import { useTeamMembers } from "@/hooks/api/use-team";

export function TeamSettings() {
  const { data: users, isLoading, error } = useTeamMembers();

  // Function to get initials from name
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  return (
    <Card className="p-6">
      <div className="space-y-6">
        <div className="flex items-center space-x-2">
          <Users className="h-5 w-5 text-primary" />
          <h2 className="text-2xl font-bold">Team Members</h2>
        </div>

        <p className="text-muted-foreground">
          View all members in your organization
        </p>

        {isLoading ? (
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="flex items-center space-x-4 rounded-lg border p-4"
              >
                <Skeleton className="h-10 w-10 rounded-full" />
                <div className="space-y-2 flex-1">
                  <Skeleton className="h-4 w-1/3" />
                  <Skeleton className="h-3 w-1/4" />
                </div>
              </div>
            ))}
          </div>
        ) : error ? (
          <div className="rounded-lg border border-destructive p-4 text-destructive">
            Failed to load team members. Please try again later.
          </div>
        ) : (
          <div className="space-y-4">
            {users?.map((user) => (
              <div
                key={user.id}
                className="flex items-center space-x-4 rounded-lg border p-4"
              >
                <Avatar>
                  <AvatarFallback>
                    {getInitials(user.get_display_name || user.email)}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1">
                  <div className="font-medium">
                    {user.get_display_name || user.email}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {user.email}
                  </div>
                </div>
                <div className="text-xs px-2 py-1 rounded-full bg-muted text-muted-foreground">
                  Member
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Card>
  );
}
